//
//

import FabricSearch from "@/components/q-fabric-search.vue";
import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";

export default {
    name: "EditRoleOnUser",
    components: {
        AQButton,
        AQModal,
        AQAvatar,
        AQChip,
        FabricSearch,
        AQCard
    },
    props: {
        currentRolesIds: {
            type: Array,
            default: () => []
        },
        userId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            opened: true,
            done: {
                label: this.$t("admin.usersAndRoles.addNewRoleOnUser.done"),
                disabled: true
            },
            groupsSelectedList: [],
            search: "",
            allRolesList: [],
            totalNumberItems: 0,
            payload: {
                pageSize: 20,
                pageNumber: 0,
                searchValue: "",
                userId: ""
            },
            isListEmpty: false,
            groupsToSend: {}
        };
    },
    computed: {
        selectionsCounter() {
            let counter;
            if (this.groupsSelectedList.length) {
                counter = `${this.groupsSelectedList.length} ${this.$t(`admin.usersAndRoles.addNewRoleOnUser.${this.groupsSelectedList.length > 1
                    ? "selections" : "selection"}`)}`;
            } else {
                counter = this.$t("admin.usersAndRoles.addNewRoleOnUser.noRoles");
            }
            return counter;
        }
    },
    watch: {
        search: {
            handler(newValue) {
                if (newValue) {
                    const searchV = newValue ? newValue.trim() : "";
                    if (searchV && searchV.length > 2) {
                        this.searchData(searchV);
                    }
                } else if (this.payload.searchValue) {
                    this.searchData();
                }
            }
        },
        groupsSelectedList: {
            handler(newValue) {
                this.done.disabled = !(newValue && newValue.length);
            },
            immediate: true
        }
    },
    created() {
        this.getGroupData();
    },
    methods: {
        ...mapActions("admin", ["getGroupList"]),
        actionsDlg($event) {
            if ($event === "primary") {
                this.$emit("modalClosed", Object.values(this.groupsToSend));
            } else {
                this.$emit("modalClosed", []);
            }
            this.opened = false;
        },
        setAvatar(item) {
            let type;
            if (item.sourceType === "AD" || item.systemType === "EXTERNAL") {
                type = item.status ? "externalGroup" : "externalDisabledGroup";
            } else if (item.systemType === "SYSTEM") {
                type = item.status ? "system" : "applicationDisabled";
            } else if (item.systemType === "APPLICATION") {
                type = item.status ? "applicationSpecific" : "applicationDisabled";
            } else {
                type = item.status ? "platform" : "applicationDisabled";
            }
            return type;
        },
        searchData(value) {
            this.payload.searchValue = value || "";
            this.payload.pageNumber = 0;
            this.payload.pageSize = 20;
            this.getGroupData();
        },
        getGroupData(loadMore) {
            if (loadMore) {
                this.payload.pageSize = 10;
                if (this.payload.pageNumber) {
                    this.payload.pageNumber += 1;
                } else {
                    this.payload.pageNumber = 2;
                }
            }
            this.payload.userId = this.userId;
            this.getGroupList(this.payload).then(
                data => {
                    const dataResponse = data.data;
                    this.allRolesList = loadMore ? [...this.allRolesList, ...dataResponse.list] : [...dataResponse.list];
                    this.totalNumberItems = dataResponse.totalCount;
                    this.isListEmpty = !(this.allRolesList && this.allRolesList.length);
                }
            );
        },
        addGroupToUser($event, role) {
            if (this.groupsToSend[role.id]) {
                delete this.groupsToSend[role.id];
            } else {
                this.groupsToSend[role.id] = role;
            }
        }
    }
};
